/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{BufferRange as e}from"./BufferRange.js";class s extends e{constructor(e,s,t){super(s,t),this.geometry=e}get isVisible(){return this.geometry.visible}get hasHighlights(){return null!=this.geometry.highlights&&this.isVisible}get hasOccludees(){return null!=this.geometry.occludees}}export{s as Instance};
